module.exports = __webpack_public_path__ + "static/media/refeicao.32ff06ec.svg";